var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotionmanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1572)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.19141C7.48265 2.19141 2.19165 7.4824 2.19165 13.9997C2.19165 20.5171 7.48265 25.8081 14 25.8081C20.5173 25.8081 25.8083 20.5171 25.8083 13.9997C25.8083 7.4824 20.5173 2.19141 14 2.19141ZM14 4.14139C19.4405 4.14139 23.8583 8.55923 23.8583 13.9997C23.8583 19.4402 19.4405 23.8581 14 23.8581C8.55949 23.8581 4.14165 19.4402 4.14165 13.9997C4.14165 8.55923 8.55949 4.14139 14 4.14139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 8.15039C9.31515 8.15039 8.15002 9.31553 8.15002 10.7504C8.15002 12.1853 9.31515 13.3504 10.75 13.3504C12.1849 13.3504 13.35 12.1853 13.35 10.7504C13.35 9.31553 12.1849 8.15039 10.75 8.15039ZM10.75 10.1004C11.1091 10.1004 11.4 10.3913 11.4 10.7504C11.4 11.1095 11.1091 11.4004 10.75 11.4004C10.3909 11.4004 10.1 11.1095 10.1 10.7504C10.1 10.3913 10.3909 10.1004 10.75 10.1004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3557 19.022L19.0223 10.3554C19.4037 9.97513 19.4037 9.35766 19.0223 8.97741C18.6421 8.59607 18.0246 8.59607 17.6443 8.97741L8.97765 17.6441C8.59632 18.0243 8.59632 18.6418 8.97765 19.022C9.3579 19.4034 9.9754 19.4034 10.3557 19.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 19.8496C18.6849 19.8496 19.85 18.6845 19.85 17.2496C19.85 15.8147 18.6849 14.6496 17.25 14.6496C15.8151 14.6496 14.65 15.8147 14.65 17.2496C14.65 18.6845 15.8151 19.8496 17.25 19.8496ZM17.25 17.8996C16.8909 17.8996 16.6 17.6087 16.6 17.2496C16.6 16.8905 16.8909 16.5996 17.25 16.5996C17.6091 16.5996 17.9 16.8905 17.9 17.2496C17.9 17.6087 17.6091 17.8996 17.25 17.8996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionmanagement);
export default __webpack_public_path__ + "static/media/Promotionmanagement.861dc39a30cb4622f88f3d528b50e294.svg";
export { ForwardRef as ReactComponent };